// extracted by mini-css-extract-plugin
export default {"root":"_1tjWg","intro":"_1DZJC","portraits":"_1RwIG","portrait":"_1Ppw3"};